import { SpecialOccurrenceStore } from '@/store/specialOccurrence';
import { Route } from 'vue-router';

export const specialOccurrenceResolver = async (to: Route, from: Route, next: any) => {
  const store = SpecialOccurrenceStore;
  await store.getById(to.params['occId']);
  next();
};
